export const container = {
  hidden: { y: '40px', opacity: 0, },
  show: {
    y: 0,
    opacity: 1,
    transition: {
      staggerChildren: 0.03,
      opacity: 1,
    },
  },
}

export const item = {
  hidden: { opacity: 0, y: '40px' },
  show: { opacity: 1, y: 0 }
}
